export default __webpack_public_path__ + "static/heart_green-158da980efa461c3d7d83929cc73c248.png";